//import logo from './logo.svg';
import "../CSS/style.css";
import "react-tooltip/dist/react-tooltip.css";
import "react-toastify/dist/ReactToastify.css";

import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from "react";
import axios from "axios";
import { useNavigate, Link, useLocation } from "react-router-dom";
import ndjsonStream from "can-ndjson-stream";
import strings from "../String";
import { Tooltip } from "react-tooltip";
import { ToastContainer, toast } from "react-toastify";
import axiosInstance from "../axiosInstance";
import * as SpeechSDK from 'microsoft-cognitiveservices-speech-sdk';

function toggleMenu(event) {
  if (event) {
    event.stopPropagation(); // Prevents event bubbling
  }

  var body = document.getElementsByTagName('body')[0];
  var isOpen = body.classList.contains('menu-open');

  if (isOpen) {
    body.classList.remove('menu-open'); // Close menu
  } else {
    body.classList.add('menu-open'); // Open menu
  }
}

function formatAIResponse(tempResponse) {
  return convertMarkdownImagesToHtml(tempResponse)
    // Headings
    .replace(/^### (.*?)$/gm, "<h3>$1</h3>")
    .replace(/^## (.*?)$/gm, "<h2>$1</h2>")
    .replace(/^# (.*?)$/gm, "<h1>$1</h1>")
    // Text formatting
    .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
    .replace(/\*(.*?)\*/g, "<em>$1</em>")
    .replace(/`(.*?)`/g, "<code>$1</code>")
    // Links
    .replace(/\[([^\]]+)\]\(([^)]+)\)/g, "<a href='$2' target='_blank'>$1</a>")
    // Lists
    .replace(/^\* (.*?)$/gm, "<li>$1</li>")
    // Citations
    .replace(/\[(\d+)\]/g, "<sup><a href='#ref$1' target='_blank'>$1</a></sup>");
}


function convertMarkdownImagesToHtml(text) {
  return text.replace(/!\[(.*?)\]\((.*?)\)/g, (match, alt, url) => {
    // Handle empty ![]()
    if (!url || url.trim() === "") {
      return "";  // skip empty images
    }

    // Wrap the image in a clickable <a> tag
    return `
      <a href="${url}" target="_blank" style="display: inline-flex;">
        <img src="${url}" alt="${alt}" style="max-width: 100%; height: auto; cursor: pointer;" />
      </a>
    `;
  });
}



const notify = () => toast("Wow so easy !");

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function Chat() {
  const [messages, setMessages] = useState([]);
  const [currentChatId, setCurrentChatId] = useState(null);
  const [currentSessionId, setCurrentSessionId] = useState(null);
  const [sessionDetails, setSessionDetails] = useState([]);
  const [themeTogglevisibility, setThemeToggleVisibility] = useState(true);
  const [chatThreads, setChatThreads] = useState([]);
  const navigate = useNavigate();

  const location = useLocation();
  //const { question } = location.state || {};

  const chatWindowClearChatText = useRef();
  const sidebarSearchClearText = useRef();

  let query = useQuery();
  let { question } = {};

  if (query) {
    question = query.get("question");
  }


  const handleOffline = () => {
    if (window.chrome?.webview) {
      //window.chrome.webview.postMessage("offline");
    }
  };


 window.addEventListener("offline", handleOffline);

  // set token in to local storage
  if (window.chrome.webview) {
    window.chrome.webview.addEventListener("message", async (event) => {
      const message = event.data;
      localStorage.setItem("authToken", message.token);
      localStorage.setItem("conversationId", message.conversationId);
      localStorage.setItem("subscriptionKey", message.subscriptionKey);
      localStorage.setItem("region", message.region);
      fetchChatThreads();
    });
  }

  const handleDeleteRoute = () => {
    var backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.parentNode.removeChild(backdrop);
    }
    navigate("/deleteaccount");
  };

  const fetchChatThreads = async () => {
    try {
      const response = await axiosInstance.get(
        "/OpenAI/distinct-sessions",
        {
        }
      );
      setChatThreads(response.data);
    } catch (error) {
      console.error("Error fetching chat threads:", error);
    }
  };

  const clearText = () => {
    if(chatWindowClearChatText.current)
    {
      chatWindowClearChatText.current.clearText();
    }
  }

  const clearSearchText = ()=> {
    if(sidebarSearchClearText.current)
    {
      sidebarSearchClearText.current.clearSearchText();
    }
  } 

  // Function to create a new chat
  const createNewChat = async () => {
    setSessionDetails('');
    localStorage.setItem("conversationId", "");
    const newSessionIDtoSet = await newSessionID('');
    localStorage.setItem("conversationId", newSessionIDtoSet);
    var body = document.getElementsByTagName('body')[0];
    var isOpen = body.classList.contains('menu-open');
    if (isOpen) {
      toggleMenu(null);
    }
    clearText();
  };

  // Function to load a chat from local storage
  const loadChat = (chatId) => {
    const chat = JSON.parse(localStorage.getItem(chatId));
    setMessages(chat.messages);
    setCurrentChatId(chatId);
  };

  // Function to send a message
  const sendMessage = async (text) => {
    const newMessage = {
      id: parseInt(Math.random() * 10000),
      text,
      type: "outgoing",
      liked: false,
      disliked: false,
    };
    setMessages((prevMessages) => [...prevMessages, newMessage]);

    try {
      const response = await axiosInstance.post("/OpenAI", text, {
        headers: {
          "Content-Type": "application/json",
        }
      });

      const data = response.data;

      // Add the response message
      setMessages((prevMessages) => [
        ...prevMessages,
        {
          id: parseInt(Math.random() * 10000),
          text: data.finalResponse,
          type: "incoming",
          currentId: data.currentId,
          liked: data.liked,
          disliked: data.disliked,
        },
      ]);

      // Save the updated chat to local storage
      const updatedChat = {
        id: currentChatId,
        title: "Chat Title",
        messages: [
          ...messages,
          newMessage,
          {
            id: parseInt(Math.random() * 10000),
            text: data.finalResponse,
            type: "incoming",
            currentId: data.currentId,
            liked: data.liked,
            disliked: data.disliked,
          },
        ],
      };
      localStorage.setItem(currentChatId, JSON.stringify(updatedChat));
    } catch (error) {
      console.error("Error fetching chat response:", error);
    }
  };

  const fetchSessionDetails = async (sessionId) => {
    try {
      const response = await axiosInstance.post(
        "/OpenAI/getWholeSession",
        {
          SessionID: sessionId,
        },
        {
          headers: {
            "Content-Type": "application/json",
          }
        }
      );
      localStorage.setItem("conversationId", sessionId);
      setSessionDetails(response.data); // Set session details to state
      var body = document.getElementsByTagName('body')[0];
      var isOpen = body.classList.contains('menu-open');
      if (isOpen) {
        toggleMenu(null);
      }
    } catch (error) {
      console.error("Error fetching session details:", error);
    }
  };

  const newSessionID = async (sessionId) => {
    try {
      const response = await axiosInstance.post(
        "/OpenAI/getWholeSession",
        {
          SessionID: sessionId,
        },
        {
          headers: {
            "Content-Type": "application/json",
          }
        }
      );

      //setSessionDetails(response.data); // Set session details to state
      return response.data;
    } catch (error) {
      console.error("Error fetching session details:", error);
    }
  };

  useEffect(() => { }, [sessionDetails]);
  return (
    <>
      <div id="comment_overLay"></div>
      <div class="hamburger">
        <span class="menu-toggle" onClick={(e) => {toggleMenu(e);}}>
          toggle menu
        </span>
      </div>
      <div id="body-overlay" onClick={(e) => {toggleMenu(e);}}></div>
      <ToastContainer />
      <div class="flex-shrink-0 overflow-x-hidden bg-token-sidebar-surface-primary w-300 sidebarMainDiv">
        <SideBar
          onNewChat={createNewChat}
          onLoadChat={loadChat}
          onSelectSession={fetchSessionDetails}
          fetchChatThreads={fetchChatThreads}
          chatThreads={chatThreads}
          clearText={clearText}
          clearSearchTextref = {sidebarSearchClearText}
        />
      </div>
      <div class="relative flex h-full max-w-full flex-1 flex-col overflow-hidden mainChatwindowDiv">
        <main class="relative h-full w-full flex-1 overflow-auto transition-width">
          <ChatWindow
            messages={messages}
            onSendMessage={sendMessage}
            chatId={currentSessionId}
            sessionDetails={sessionDetails}
            themetoggleVisibility={setThemeToggleVisibility}
            fetchSessionDetails={fetchSessionDetails}
            fetchChatThreads={fetchChatThreads}
            clearChatInputref={chatWindowClearChatText}
          />
        </main>
      </div>
      <div
        className="modal fade"
        id="deleteAccount"
        tabIndex="-1"
        aria-labelledby="deleteAccountLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="deleteAccountLabel">
                Delete Account
              </h5>
              <button
                type="button"
                className="btn-close btn-close-custom "
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p>
                Deleting your account will remove all of your information. This
                cannot be undone.
              </p>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                <label class="form-check-label" for="flexCheckDefault">
                  To confirm this.
                </label>
              </div>
              <div class="col-auto mt-3">
                <button onClick={handleDeleteRoute}
                  type="button"
                  class="btn btn-primary"
                  data-bs-dismiss="modal"
                >
                  Yes
                </button> &nbsp;
                <button type="button" class="btn btn-secondary">
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const ThemeToggle = () => {
  // State to track whether dark mode is enabled
  const [isDarkMode, setIsDarkMode] = useState(() => {
    // Initialize state based on the value stored in localStorage
    return localStorage.getItem("themeColor") === "light_mode";
  });

  const changeTheme = async (e) => {
    setIsDarkMode(!isDarkMode);
    setTimeout(async () => {
      try {
        const currentThemeName = localStorage.getItem("themeColor");

        const response = await axiosInstance.post(
          "/OpenAI/saveTheme",
          {
            themeName: currentThemeName,
          }
        );

        if (response.data) {
          // Handle successful response here
        }
      } catch (error) {
        console.error("Error saving theme:", error);
      }
    }, 200);
  };

  // Effect hook to apply the theme and persist it to localStorage
  useEffect(() => {
    const themeButtonInnerText = isDarkMode ? "light_mode" : "dark_mode";
    const logoImgSrc = isDarkMode
      ? "Img/cimatron-logo-white.png"
      : "Img/cimatron-logo-720x177.png";

    const copilotLogoImgSrc = isDarkMode
      ? "Img/copilot-icon-text-bubble-white-512.png"
      : "Img/copilot-icon-text-bubble-black-512.png";

    document.body.classList.toggle("dark-mode", isDarkMode);
    localStorage.setItem("themeColor", themeButtonInnerText);
    // Update the logo image source if you have a logo that needs to change
    const logoImg = document.getElementById("logo-img");
    const copilotLogoImg = document.getElementById("copilot-icon-chat");
    const copilotLogoImgDefault = document.getElementById("copilot-icon-default");

    if (logoImg) {
      logoImg.src = logoImgSrc;
    }
    if (copilotLogoImg) {
      copilotLogoImg.src = copilotLogoImgSrc;
    }
    if (copilotLogoImgDefault) {
      copilotLogoImgDefault.src = copilotLogoImgSrc;
    }
  }, [isDarkMode]);

  // useEffect(() => {
  //   const fetchTheme = async () => {
  //     try {
  //       const response = await axios.get(
  //         `${strings.apiBaseUrl}/OpenAI/getTheme`
  //       );
  //       //setTheme(response.data.user.Theme);

  //       if (response.data.theme == "light_mode") {
  //         setIsDarkMode(true);
  //         localStorage.setItem("themeColor", "light_mode");
  //       } else if (response.data.theme == "dark_mode") {
  //         setIsDarkMode(false);
  //         localStorage.setItem("themeColor", "dark_mode");
  //       }
  //     } catch (error) {
  //       console.error("Error fetching theme:", error);
  //     }
  //   };

  //   fetchTheme();
  // }, []);

  return (
    <div className="theme-toggle">
      <input
        type="checkbox"
        className="sr-only"
        id="darkmode-toggle"
        checked={isDarkMode}
        onChange={changeTheme} // Call `changeTheme` when the checkbox changes
      />
      <label htmlFor="darkmode-toggle" className="toggle">
        <span data-tooltip-id="toggle-theme">Toggle dark mode</span>
      </label>
      <Tooltip id="toggle-theme" place="bottom" content="Toggle Theme" />
    </div>
  );
};

const SideBar = forwardRef (({
  onNewChat,
  onLoadChat,
  onSelectSession,
  fetchChatThreads,
  chatThreads,
  clearText,
  clearSearchTextref
}) => {
  const [filteredChatThreads, setFilteredChatThreads] = useState(chatThreads);
  const [searchTerm, setSearchTerm] = useState("");
  const [userName, setUserName] = useState("");

  const navigate = useNavigate();

  useImperativeHandle(clearSearchTextref, () => ({
    clearSearchText: () => {
      setSearchTerm("");
    },
  }));

  useEffect(() => {
    // This effect runs whenever chatThreads or searchTerm changes
    const term = searchTerm.toLowerCase();
    if (term) {
      const filtered = chatThreads.filter((thread) =>
        thread.oldestRequest.toLowerCase().includes(term)
      );

      setFilteredChatThreads(filtered);
    } else {
      setFilteredChatThreads(chatThreads);
    }
  }, [searchTerm, chatThreads]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleLogout = async () => {
    try {
      await axiosInstance.post(
        "/Login/logout",
        {},
        {
        }
      );
      navigate("/login"); // Redirect to login page
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  useEffect(() => {
    // fetchChatThreads();
  }, []);
  useEffect(() => {
  }, [chatThreads]);
  const handleButtonClick = () => {
    fetchChatThreads();
  };

  useEffect(() => {
  }, []);

  function removeDomainFromEmail(email) {
    // Find the index of the '@' character
    const atIndex = email.indexOf('@');
    // If '@' is not found, return the original email
    if (atIndex === -1) {
      return email;
    }
    // Return the part of the email before the '@'
    return email.substring(0, atIndex);
  }

  return (
    <nav
      className="navbar navbar-expand-lg real-menu d-flex flex-column"
      role="navigation"
    >
      <div className="sidebar-listIteam">
        <span className="closebtn close-btn" onClick={(e) => toggleMenu(e)}>
          &times;
        </span>
        <a className="navbar-brand navbar-start">
          <img
            alt="logo"
            id="logo-img"
            className="logo"
            src="/Img/cimatron-logo-720x177.png"
          />
        </a>
        <div className="d-flex flex-row py-4 px-1">
          <div className="threads">Threads</div>
          {<div className="new-chat">
            <span
              id="add-btn-sidebar"
              data-tooltip-id="new-chat-tooltip"
              className="material-icons"
              onClick={() => {
                onNewChat();
                setSearchTerm("");
                handleButtonClick();
              }}
            >
              add
            </span>
            <Tooltip id="new-chat-tooltip" place="top" content="New Chat" />
          </div>}

        </div>
        <div
          id="searchInput"
          className="searchInput"
        >
          <a href="" target="_blank" hidden></a>
          <input id="search-input" type="text" placeholder="Search..."   value={searchTerm}
          onChange={handleSearchChange}/>
          <div id="resultBox" className="resultBox"></div>

          <div className="icon">
            <span className="material-icons">search</span>
          </div>
        </div>
        <ul className="chat-threads">
          {filteredChatThreads.map((thread) => (
            <li
              key={thread.sessionID}
              onClick={() => {
                clearText();
                setSearchTerm("");
                onSelectSession(thread.sessionID);
              }}
            >
              <small>{new Date(thread.timestamp).toLocaleString()}</small>
              <br></br>
              {thread.oldestRequest}
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
});

const ChatSearch = ({ chatThreads, onSelectSession }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredThreads, setFilteredThreads] = useState(chatThreads);

  const handleSearchChange = (event) => {
    const term = event.target.value.toLowerCase();
    setSearchTerm(term);

    const filtered = chatThreads.filter((thread) =>
      thread.oldestRequest.toLowerCase().includes(term)
    );
    setFilteredThreads(filtered);
  };

  return (
    <>
      <div
        id="searchInput"
        className="searchInput"
        value={searchTerm}
        onChange={handleSearchChange}
      >
        <a href="" target="_blank" hidden></a>
        <input id="search-input" type="text" placeholder="Search..." />
        <div id="resultBox" className="resultBox"></div>
        <div className="icon">
          <span className="material-icons">search</span>
        </div>
      </div>
      <ul className="chat-threads">
        {filteredThreads.map((thread) => (
          <li
            key={thread.sessionID}
            onClick={() => onSelectSession(thread.sessionID)}
          >
            <small>{new Date(thread.timestamp).toLocaleString()}</small>
            <br></br>
            {thread.oldestRequest}
          </li>
        ))}
      </ul>
    </>
  );
};

const ChatWindow = forwardRef(({
  chatId,
  sessionDetails,
  themetoggleVisibility,
  fetchSessionDetails,
  fetchChatThreads,
  question,
  clearChatInputref
}) => {
  const [chatInput, setChatInput] = useState("");
  const [messages, setMessages] = useState([]);
  const [tempMessage, setTempMessage] = useState("");
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [selectedMessageId, setSelectedMessageId] = useState(null);
  const [comments, setComments] = useState({});
  const [postedComment, setPostedComment] = useState();
  const chatWindowRef = useRef(null);
  const wholeChatWindowRef = useRef(null);
  const navigate = useNavigate();

  const [ip, setIp] = useState(null);
  const [location, setLocation] = useState(null);
  const [isListening, setIsListening] = useState(false);
  const [isLikeDislikeClick, setIsLikeDislikeClick] = useState(false);
  const [suggestedquestions, setSuggestedQuestions] = useState([]);

  const startRecognition = () => {
    if (!isListening) {
      const speechConfig = SpeechSDK.SpeechConfig.fromSubscription(localStorage.getItem('subscriptionKey'), localStorage.getItem('region'));
      speechConfig.speechRecognitionLanguage = 'en-US';
      const audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
      const recognizer = new SpeechSDK.SpeechRecognizer(speechConfig, audioConfig);
      recognizer.sessionStarted = (sender, event) => {
        setIsListening(true);
      };
      recognizer.sessionStopped = (sender, event) => {
        setIsListening(false);
      }
      // Call recognizeOnceAsync for speech recognition
      recognizer.recognizeOnceAsync(
        (result) => {
          setIsListening(false); // Stop recognizing
          if (result.reason === SpeechSDK.ResultReason.RecognizedSpeech) {
            setChatInput(result.text); // Set recognized text
          } else if (result.reason === SpeechSDK.ResultReason.NoMatch) {
            //setChatInput("");
          } else if (result.reason === SpeechSDK.ResultReason.Canceled) {
            const cancellationDetails = result.cancellationDetails;
            console.log(`Speech Recognition canceled: ${cancellationDetails.reason}`);
            if (cancellationDetails.reason === SpeechSDK.CancellationReason.Error) {
              console.log(`Error details: ${cancellationDetails.errorDetails}`);
            }
          }
        },
        (err) => {
          setIsListening(false);
          console.log(`Error occurred: ${err}`);
        }
      );
    }
  };
  const stopRecognition = () => {
    //setIsListening(false);
  }

  useImperativeHandle(clearChatInputref, () => ({
    clearText: () => {
      setChatInput("");
      setSuggestedQuestions([]);
    },
  }));

  // Effect hook to manage cleanup or re-initialization if necessary
  useEffect(() => {
    // Clean up logic when component unmounts or when it's rendered multiple times
    return () => {
      setIsListening(false);
    };
  }, []);

  useEffect(() => {
    if (chatWindowRef.current) {
      chatWindowRef.current.scrollTop = chatWindowRef.current.scrollHeight;
    }
  }, [tempMessage]);


  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (question) {
        handleQuestionClick(question);
      }
    }, 100);
    return () => clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    return () => {
    };
  }, []);

  function isLikeFeedback(feedback) {
    if (feedback == "2") {
      return true;
    } else {
      return false;
    }
  }

  function isDisLikeFeedback(feedback) {
    if (feedback == "3") {
      return true;
    } else {
      return false;
    }
  }

  useEffect(() => { }, [sessionDetails]);

  useEffect(() => {
    if (sessionDetails.length > 0) {
      const initialMessages = [];
      const initialComments = [];

      sessionDetails.forEach((detail) => {
        const bulletPointResponse = detail.response.replace(
          /^- (.*)$/gm,
          "<li>$1</li>"
        );

        // Wrap the entire content within <ul> tags if there are bullet points
        const finalResponse = bulletPointResponse.includes("<li>")
          ? `<ul class="bullet-list">${bulletPointResponse}</ul>`
          : bulletPointResponse;

        initialMessages.push({
          currentId: "",
          text: detail.request,
          type: "outgoing",
          //timestamp: detail.createdDate
        });

        //create bold marking in message
        let detailedResponse = detail.response;
        detailedResponse = detailedResponse.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");

        initialMessages.push({
          currentId: detail.id,
          //text: detail.response,
          text: detailedResponse,
          type: "incoming",
          timestamp: detail.createdDate,
          liked: isLikeFeedback(detail.userReaction),
          disliked: isDisLikeFeedback(detail.userReaction),
        });

        if (detail.userFeedback) {
          initialComments[detail.id] = [{
            userFeedback: detail.userFeedback,
            answerRating: detail.answerRating,
            copilotRating: detail.copilotRating,
            isIssueResolved: detail.isIssueResolved,
            createdDate: detail.feedBackDate,
          }];
        }
      });

      setMessages(initialMessages);
      setComments(initialComments);
    } else {
      setMessages([]);
      setComments({});
    }
  }, [sessionDetails]);

  const copyResponse = async (text) => {
    try {
      //const cleanedText = htmlToCleanText(text.replace(/<a href=".*?">.*?<\/a>/gs, "")); // Remove <a> tags
      const cleanedText = extractCleanTextWithCitations(text);
      await navigator.clipboard.writeText(cleanedText);
      //alert('Text copied to clipboard!');
      toast.success("Copied!", {
        position: "top-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };

function extractCleanTextWithCitations(html) {
  const temp = document.createElement("div");
  temp.innerHTML = html;

  // STEP 1 — FIND citation section in raw HTML
  const rawHtml = temp.innerHTML;
  const citationStart = rawHtml.toLowerCase().indexOf("citations");

  let citationSectionHtml = "";
  if (citationStart !== -1) {
    citationSectionHtml = rawHtml.substring(citationStart);
  }

  // STEP 2 — Extract ONLY citation URLs from citation section
  let citationLinks = [];
  if (citationSectionHtml) {
    const cdiv = document.createElement("div");
    cdiv.innerHTML = citationSectionHtml;
    citationLinks = [...cdiv.querySelectorAll("a")].map(a => a.href);
  }

  // ***** FIX: Remove duplicates *****
  citationLinks = [...new Set(citationLinks)];

  // STEP 3 — Convert ALL <a> tags to plain text gracefully
  temp.querySelectorAll("a").forEach(a => {
    const text = a.innerText.trim();
    const url = a.href;

    if (citationLinks.includes(url)) {
      // For citations: keep only text (URL will be added later)
      a.replaceWith(document.createTextNode(""));
    } else {
      // For normal area: keep ONLY visible text
      a.replaceWith(document.createTextNode(text));
    }
  });

  // STEP 4 — Convert full HTML to plain readable text
  let cleanText = temp.innerText;

  // STEP 5 — Remove old "Citations:" because we rebuild it
  cleanText = cleanText.replace(/Citations[:]?/gi, "").trim();

  // STEP 6 — Append formatted citation list (no duplicates)
  if (citationLinks.length > 0) {
    cleanText += "\n\nCitations:\n";
    citationLinks.forEach((url, index) => {
      cleanText += `${index + 1}. ${url}\n`;
    });
  }

  return cleanText.trim();
}


  // Function to add a new message to the messages state
  const addMessage = (text, type = "incoming", options = {}) => {
    const newMessage = {
      id: parseInt(Math.random() * 10000),
      text,
      type,
      ...options,
    };
    setMessages((prevMessages) => [...prevMessages, newMessage]);
  };

  // Function to simulate the typing animation
  const showTypingAnimation = (trimmedInput) => {
    addMessage("", "typing");
    //getChatResponse();
    sendNonBlockingMessage(trimmedInput);
  };

  // Function to fetch a response from the API using axios
  const getChatResponse = async () => {
    const userText = chatInput.trim();

    try {
      const response = await axiosInstance.post(
        "/OpenAI",
        userText,
        {
          headers: {
            "Content-Type": "application/json",
          }
        }
      );

      const data = response.data;

      // Replace the typing animation with the API response
      setMessages((prevMessages) =>
        prevMessages.map((msg) =>
          msg.type === "typing"
            ? {
              ...msg,
              text: parseResponse(data.finalResponse),
              type: "incoming",
              currentId: data.currentId,
            }
            : msg
        )
      );
      setSelectedMessageId(data.currentId);
    } catch (error) {
      console.error("Error fetching chat response:", error);
      setMessages((prevMessages) =>
        prevMessages.map((msg) =>
          msg.type === "typing"
            ? {
              ...msg,
              text: "Oops! Something went wrong while retrieving the response. Please try again.",
              type: "error",
            }
            : msg
        )
      );
    }
  };

  const saveHistory = async (messageInput) => {
    try {


      const ipResponse = await fetch("https://api.ipify.org?format=json");
      const data = await ipResponse.json();
      setIp(data.ip);

      const locationResponse = await fetch(
        `https://ipinfo.io/${data.ip}/json`
      );
      const locationData = await locationResponse.json();

      setLocation(locationData);

      const requestBody = {
        status: messageInput.status,
        request: messageInput.request,
        response: messageInput.response,
        userName: messageInput.userName,
        sessionID: "",
        City: locationData.city,
        Country: locationData.country,
        Region: locationData.region,
        Id: messageInput.feedbackId,
      };

      const response = await axiosInstance.post(
        "/OpenAI/savehistory",
        requestBody,
        {
        }
      );

      // Return the messageID from the response
      return response.data.currentId;
    } catch (error) {
      //navigate('/login');
      return null;
    }
  };

  const delay = async (ms) => {
    return new Promise((resolve) =>
      setTimeout(resolve, ms));
  };

  const sendNonBlockingMessage = async (trimmedInput) => {
    const messageInput = trimmedInput;
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${strings.apiBaseUrl}/OpenAI/send-stream`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify(messageInput), // Wrap the message input in an object
      credentials: "include",
    });

    if (!response.ok) {
      return;
    }

    const theNdJsonStream = ndjsonStream(response.body);
    const reader = theNdJsonStream.getReader();

    let tempResponse = "";
    let citations = [];
    let suggestedQueries = [];
    let feedback_id = "";
    while (true) {
      const { done, value } = await reader.read();
      if (done) {
        break;
      }
      const asJson = value;
      feedback_id = asJson.feedback_id;
      tempResponse = asJson.response;
      citations = asJson.citations || [];
      suggestedQueries = asJson.suggested_queries || [];
      setTempMessage(tempResponse);
      if (tempResponse != "") {
        await delay(200);
      }
    }
    setSuggestedQuestions(suggestedQueries);
    if (citations.length > 0) {
      const citationLinks = citations
        .map((citation, index) => {
          if (citation.external_url === null || citation.external_url === undefined || citation.external_url.trim() === "") {
            return `<li><a href="${citation.url}" target="_blank">${citation.original_filename}</a></li>`;
          }
          else {
            return `<li><a href="${citation.external_url}" target="_blank">${citation.external_url}</a></li>`;
          }
        })
        .join("");
      tempResponse += `<br /><br />Citations:<br /><ul>${citationLinks}</ul>`;
    }
    const uniqueID = `id-${Date.now()}-${Math.random()
      .toString(36)
      .substr(2, 9)}`;

    tempResponse = formatAIResponse(tempResponse);         //tempResponse.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");

    // Replace all heading levels at once
    tempResponse = tempResponse.replace(/^(#{1,6})\s+(.*?)$/gm, function (match, hashes, text) {
      const level = hashes.length;
      return `<h${level}>${text}</h${level}>`;
    });

    const messageID = await saveHistory({
      status: "Successfull",
      request: messageInput,
      response: tempResponse,
      userName: "",
      feedbackId: feedback_id,
    });

    const bulletPointResponse = tempResponse.replace(
      /^- (.*)$/gm,
      "<li>$1</li>"
    );

    // Wrap the entire content within <ul> tags if there are bullet points
    const finalResponse = bulletPointResponse.includes("<li>")
      ? `<ul class="bullet-list">${bulletPointResponse}</ul>`
      : bulletPointResponse;

    setMessages((prevMessages) =>
      prevMessages.map((msg) =>
        msg.type === "typing"
          ? {
            ...msg,
            text: tempResponse,
            type: "incoming",
            currentId: messageID,
          }
          : msg
      )
    );
    setTempMessage("");
    fetchSessionDetails(localStorage.getItem("conversationId"));
    fetchChatThreads();
  };

  const parseResponse = (response) => {
    // Remove escaped quotes around specific terms
    response = response.replace(/\\"/g, '"');

    // Split the response by double quotes to separate URLs from text
    const parts = response.split(/(?="https?:\/\/)|(?<=\s)(?=")/);
    let linkIndex = 1;
    return parts
      .map((part) => {
        if (part.startsWith('"https://')) {
          const url = part.replace(/"/g, ""); // Remove any double quotes
          const urlObj = new URL(url);
          const pathnameParts = urlObj.pathname.split("/");
          const pdfName = pathnameParts[pathnameParts.length - 1]; // Extract the PDF name
          const pageNumberMatch = url.match(/#page=(\d+)/); // Extract the page number
          const pageNumber = pageNumberMatch
            ? ` - Page ${pageNumberMatch[1]}`
            : "";
          const linkText = `${pdfName}${pageNumber}`;
          return `<li><a href="${url}" target="_blank">${linkText}</a></li>`;
        }
        return part;
      })
      .join(""); // Join parts with line breaks
  };

  const handleLikeDislike = async (id, action, feedback_id) => {
    //console.log("idforLike", id)
    setIsLikeDislikeClick(true);
    try {
      await axiosInstance.post(
        "/OpenAI/feedback",
        { id, action },
        {
          headers: {
            "Content-Type": "application/json",
          }
        }
      );

      // Update the message to reflect the like/dislike action
      setMessages((prevMessages) =>
        prevMessages.map((msg) =>
          msg.currentId === id
            ? {
              ...msg,
              liked: action === "like",
              disliked: action === "dislike",
            }
            : msg
        )
      );
      //console.log("messages after Like Dislike ",messages);
    } catch (error) {
      console.error(`Error sending ${action} feedback:`, error);
    }
  };

  // Function to toggle the sidebar for comments
  const toggleSidebar = (messageId) => {
    //console.log(messageId);

    var body = document.getElementsByTagName('body')[0];
    var isOpen = body.classList.contains('comment-sidebar-open');

    if (isOpen) {
      body.classList.remove('comment-sidebar-open'); // Close menu
    } else {
      body.classList.add('comment-sidebar-open'); // Open menu
    }

    setSelectedMessageId(messageId);
    setSidebarVisible(!sidebarVisible);
    if (!sidebarVisible) {
      const chatWindow = wholeChatWindowRef.current;
      const chatWindowWidth = chatWindow.clientWidth;
      if (chatWindowWidth > 600) {
        // chatWindow.style.width = `calc(${chatWindowWidth}px - 300px)`;
      }
      themetoggleVisibility(false);
    } else {
      const chatWindow = wholeChatWindowRef.current;
      chatWindow.style.width = "";
      themetoggleVisibility(true);
    }
  };
  // Function to add a comment
  const addComment = async (commentText, experience, IsIssueResolved, quality, currentTimestamp) => {
    try {
      // Replace with your actual API endpoint
      const response = await axiosInstance.post(
        "/OpenAI/comments",
        {
          MessageId: selectedMessageId,
          Comment: commentText,
          AnswerRating: quality,
          CopilotRating: experience,
          IsIssueResolved: IsIssueResolved
        },
        {
          headers: {
            "Content-Type": "application/json",
          }
        }
      );

      // Assuming the response contains the updated comment information
      const data = response.data;
      setComments((prevComments) => ({
        ...prevComments,
        [selectedMessageId]: [
          ...(prevComments[selectedMessageId] || []),
          {
            userFeedback: commentText,
            answerRating: quality,
            copilotRating: experience,
            isIssueResolved: IsIssueResolved,
            createdDate: currentTimestamp
          }
        ],
      }));
      //console.log("Comments ", comments[selectedMessageId]);
      toggleSidebar();
    } catch (error) {
      console.error("Error adding comment:", error);
    }
  };

  const clearComments = async (messageId) => {
    // Replace with your actual API endpoint
    const response = await axiosInstance.post(
      "/OpenAI/comments",
      {
        MessageId: selectedMessageId,
        Comment: "",
        AnswerRating: "",
        CopilotRating: "",
        IsIssueResolved: ""
      },
      {
        headers: {
          "Content-Type": "application/json",
        }
      }
    );

    // Assuming the response contains the updated comment information
    const data = response.data;
    setComments((prevComments) => ({
      ...prevComments,
      [messageId]: [],
    }));

    toggleSidebar();
  };

  useEffect(() => {
    if (comments[selectedMessageId]) {
    }
  }, [comments, selectedMessageId]);

  // Scroll to the bottom of the chat window whenever messages update
  useEffect(() => {
    if (chatWindowRef.current) {
      if (!isLikeDislikeClick) {
        chatWindowRef.current.scrollTop = chatWindowRef.current.scrollHeight;
      }
      setIsLikeDislikeClick(false);
    }
  }, [messages]);

  // Render function for individual chat messages
  const renderMessage = (message) => {
    if (message.type === "typing") {
      return (
        <div className="chat-content d-flex flex-row-reverse">
          <div className="chat-details ChatItem-chatText">
            <p>{tempMessage}</p>
            <div className="typing-animation">
              <div className="typing-dot" style={{ "--delay": "0.2s" }}></div>
              <div className="typing-dot" style={{ "--delay": "0.3s" }}></div>
              <div className="typing-dot" style={{ "--delay": "0.4s" }}></div>
            </div>
          </div>
          <img src="Img/chatbot.png" alt="chatbot-img" />
        </div>
      );
    } else if (message.type === "incoming") {
      return (
        <>
          <div className="chat-content d-flex flex-row-reverse">
            <div className="chat-details ChatItem-chatText">
              <p dangerouslySetInnerHTML={{ __html: message.text }}></p>
            </div>

            <img src="Img/chatbot.png" alt="chatbot-img" />
          </div>
          <div className="chat-icon-expert">
            <span
              data-tooltip-id="like-tooltip"
              onClick={() => handleLikeDislike(message.currentId, "like")}
              className={`material-icons ${message.liked ? "green" : ""}`}
            >
              thumb_up
            </span>
            <Tooltip id="like-tooltip" place="top" content="Like" />
            <span
              data-tooltip-id="dislike-tooltip"
              onClick={() => handleLikeDislike(message.currentId, "dislike")}
              className={`material-icons ${message.disliked ? "red" : ""}`}
            >
              thumb_down
            </span>
            <Tooltip id="dislike-tooltip" place="top" content="Dislike" />
            <span data-tooltip-id="copyResponse-tooltip" onClick={() => copyResponse(message.text)} class="material-icons">content_copy</span>
            <Tooltip id="copyResponse-tooltip" place="top" content="Copy Text" />
            <span data-tooltip-id="add-comment-tooltip" onClick={() => toggleSidebar(message.currentId)} className={`material-icons ${comments[message.currentId] && comments[message.currentId].length > 0 ? 'primary-color' : ''}`} title="Feedback">
              rate_review
            </span>
            <Tooltip
              id="add-comment-tooltip"
              place="top"
              content="Feedback"
            />
          </div>
          {comments[message.currentId] &&
            comments[message.currentId].length > 0 && (
              <div className="chat box">
                <div id="text" className="text" data-clamp="3">
                  {
                    comments[message.currentId][
                      comments[message.currentId].length - 1
                    ].userFeedback
                  }
                </div>
              </div>
            )}
        </>
      );
    } else {
      return (
        <>
          <div className="chat-content d-flex flex-row">
            <div className="chat-details ChatItem-chatText">
              <p>{message.text}</p>
            </div>
          </div>
          <div class="chat-icon-customer">
            <span
              data-tooltip-id="copyque-tooltip"
              onClick={() => copyResponse(message.text)}
              class="material-icons"
            >
              content_copy
            </span>
            <Tooltip
              id="copyque-tooltip"
              place="bottom"
              content="Copy Content"
            />
          </div>
        </>
      );
    }
  };

  const handleSendMessage = (e, input) => {
    //console.log('Send button clicked', e);
    setSuggestedQuestions([]);
    if (e) {
      const keyCode = e.which || e.keyCode;

      if (keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        const trimmedInput = chatInput.trim();
        if (trimmedInput) {
          addMessage(trimmedInput, "outgoing");
          setChatInput("");
          showTypingAnimation(trimmedInput);
        }
      }
    } else if (input) {
      const trimmedInput = input.trim();
      if (trimmedInput) {
        addMessage(trimmedInput, "outgoing");
        setChatInput("");
        showTypingAnimation(trimmedInput);
      }
    }
  };

  const handleQuestionClick = (question) => {
    handleSendMessage(null, question);
  };

  let listOfSuggestedQuires = suggestedquestions;

  return (
    <div
      role="Chat-Window"
      class="flex h-full flex-col focus-visible:outline-0"
      tabindex="0"
      ref={wholeChatWindowRef}
    >
      <div class="chat-header" id="chat-header">
        <img
          src="Img/copilot-icon-text-bubble-black-512.png"
          alt="copilot-icon-text-bubble-white"
          className="copilot-icon-chat" id="copilot-icon-chat"
        /> <h3 class="px-2">Cimatron Copilot</h3></div>
      <div class="flex-1 overflow-hidden">
        <div class="relative h-full">
          <div className="ChatWindow padding-chatwindow " ref={chatWindowRef}>
            <div className="flex h-full flex-col items-center justify-center">
              {messages.length === 0 && (
                <div className="default-text">
                  <img
                    src="Img/copilot-icon-text-bubble-black-512.png"
                    alt="copilot-icon-text-bubble-white"
                    className="copilot-icon-default" id="copilot-icon-default"
                  />
                  <h1>Welcome to Cimatron Copilot</h1>
                  <p>
                    Your use of Cimatron Copilot is subject to the <a id="terms-privacyPolicy" href="https://www.cimatron.com/en/cimatron-copilot-terms-of-use" target="_blank">Terms of Use</a> and <a id="transparencyNotice" href="https://www.cimatron.com/en/cimatron-copilot-transparency-notice" target="_blank">Transparency Notice</a>.
                    You accept, and agree to comply with, the Terms of Use (and acknowledge the Transparency Notice) by accessing and/or using the Cimatron Copilot.
                    <b>
                      &nbsp;You must not access and/or use the Cimatron Copilot if you do not accept, or agree to comply with, the Terms of Use.</b>
                  </p>
                  <p> The Cimatron Copilot is an AI-powered assistant and is here to help with enquiries about our products and to provide guidance on common trouble shooting issues.</p>
                  <p>Please enter your question to get started.</p>
                </div>
              )}
              {messages.map((message) => (
                <div
                  key={message.id}
                  className={`chat ${message.type === "outgoing"
                    ? "outgoing ChatItem--customer"
                    : "ChatItem--expert"
                    }`}
                >
                  {renderMessage(message)}
                </div>
              ))}
              {listOfSuggestedQuires !== null && listOfSuggestedQuires.length > 0 ?
                <div id="preQuestions" class="flex flex-row flex-wrap justify-content-center gap-2">
                  {listOfSuggestedQuires.map((item, index) => (
                    <div onClick={() =>
                      handleQuestionClick(item)
                    }>{item}</div>
                  ))}
                </div> : <div></div>
              }
            </div>
          </div>
        </div>
      </div>
      <div id="typing-container" class="w-full padding-typingchatwindow">
        <div class="px-3 text-base">
          <div class="mx-auto flex flex-1 gap-3 text-base">
            <div class="typing-content w-full">
              <div class="typing-textarea input-group">
                <textarea
                  value={chatInput}
                  placeholder="Shift + Enter for a new line"
                  onChange={(e) => setChatInput(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handleSendMessage(e)}
                  // onkeyup={(e) => searchSuggestion(e)}
                  style={{ margin: "1px" }}
                  id="chat-type-area"
                />
                <span id="mic" data-tooltip-id="mic-tooltip" class="material-icons" onClick={isListening ? stopRecognition : startRecognition}> {isListening ? 'mic' : 'mic_off'}</span>
                <span
                  data-tooltip-id="sendquestion-tooltip"
                  class="material-icons"
                  onClick={() => handleQuestionClick(chatInput)}
                  id="send-btn"
                  style={{ cursor: "pointer" }}>
                  send
                </span>
                <Tooltip id="sendquestion-tooltip" place="top" content="Send" />
                <Tooltip id="mic-tooltip" place="top" content="Dictate" />
              </div>
            </div>
          </div>
        </div>
      </div>
      {sidebarVisible && (
        <Sidebar
          messageId={selectedMessageId}
          addComment={addComment}
          existingComment={comments[selectedMessageId]}
          toggleSidebar={toggleSidebar}
          clearComments={clearComments}
        />
      )}
    </div>
  );
});

const Sidebar = ({
  messageId,
  addComment,
  existingComment,
  toggleSidebar,
  clearComments,
}) => {
  const [commentText, setCommentText] = useState(
    existingComment && existingComment.length > 0
      ? existingComment[existingComment.length - 1].userFeedback === null ? "" : existingComment[existingComment.length - 1].userFeedback
      : ""
  );

  const [experience, setExperience] = useState(
    existingComment && existingComment.length > 0
      ? existingComment[existingComment.length - 1].copilotRating === null ? "" : existingComment[existingComment.length - 1].copilotRating.toString()
      : ""
  );
  const [resolved, setResolved] = useState(
    existingComment && existingComment.length > 0
      ? existingComment[existingComment.length - 1].isIssueResolved === null ? "" : existingComment[existingComment.length - 1].isIssueResolved.toString()
      : ""
  );
  const [quality, setQuality] = useState(
    existingComment && existingComment.length > 0
      ? existingComment[existingComment.length - 1].answerRating === null? "" : existingComment[existingComment.length - 1].answerRating.toString()
      : ""
  );

  const handleExperienceChange = (event) => {
    setExperience(event.target.value);
  };

  const handleResolvedChange = (event) => {
    setResolved(event.target.value);
  };

  const handleQualityChange = (event) => {
    setQuality(event.target.value);
  };


  const [hasExistingComment, setHasExistingComment] = useState(
    existingComment && existingComment.length > 0 ? true : false
  );
  const [timestamp, setTimestamp] = useState(existingComment && existingComment.length > 0
    ? existingComment[existingComment.length - 1].createdDate === null ? "" : new Date(existingComment[existingComment.length - 1].createdDate.toString()).toLocaleString()
    : "");
  const handleAddComment = () => {
    if (commentText.trim()) {
      const currentTimestamp = new Date().toLocaleString();
      addComment(commentText, experience, resolved, quality, currentTimestamp);
      setTimestamp(currentTimestamp);
      setHasExistingComment(true);
    }
  };

  const divRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (divRef.current && !divRef.current.contains(event.target)) {
        toggleSidebar();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [divRef]);

  return (
    <div ref={divRef} id="mySidenav" className="sidenav" style={{ width: "400px" }}>
      <a
        href="javascript:void(0)"
        className="closebtn"
        onClick={() => toggleSidebar()}
      >
        ×
      </a>
      <div className="container p-4">
        <h4>Cimatron Copilot Feedback</h4>
        {hasExistingComment ? (
          <ul className="posts">
            <li>
              <div>
                <div className="comment-block" id="comment-6054">
                  <div id="comments-details">
                    <h6 className="user-details"></h6>
                    <p className="comments" id="comments">
                      {commentText}
                    </p>
                    <small>{timestamp}</small>
                  </div>
                  <div className="action-icon">
                    <span
                      data-tooltip-id="edit-comment-tooltip"
                      onClick={() => setHasExistingComment(false)}
                      className="material-icons"
                    >
                      edit
                    </span>
                    <Tooltip
                      id="edit-comment-tooltip"
                      place="top"
                      content="Edit"
                    />
                    <span
                      data-tooltip-id="delete-comment-tooltip"
                      onClick={() => {
                        setCommentText("");
                        setHasExistingComment(false);
                        clearComments(messageId);
                      }}
                      className="material-icons"
                    >
                      delete
                    </span>
                    <Tooltip
                      id="delete-comment-tooltip"
                      place="top"
                      content="Delete"
                    />
                  </div>
                </div>
              </div>
            </li>
          </ul>
        ) : (
          // <div id="add-comment" style={{ display: "block" }}>
          //  <div className="form-group comment-textarea my-4">
          //     <textarea
          //       className="form-control status-box"
          //       rows="3"
          //       placeholder="Enter your comment here..."
          //       value={commentText}
          //       onChange={(e) => setCommentText(e.target.value)}
          //     ></textarea>
          //   </div>
          //   <div className="button-group mt-3">
          //     <button
          //       onClick={handleAddComment}
          //       className="btn btn-primary comment-post"
          //       disabled={!commentText.trim()}
          //     >
          //       Post
          //     </button>
          //   </div>
          // </div>
          <div id="add-comment" style={{ display: "block" }} className="add-feedback">

            <div className="d-flex flex-column mt-4">
              <div class="question">
                <p><b>How would you rate the overall experience with Cimatron Copilot?</b></p>
                <div class="rating">
                  <label><input type="radio" name="experience" value="1" checked={experience === "1"} onChange={handleExperienceChange} /> 1 - Poor</label>
                  <label><input type="radio" name="experience" value="2" checked={experience === "2"} onChange={handleExperienceChange} /> 2</label>
                  <label><input type="radio" name="experience" value="3" checked={experience === "3"} onChange={handleExperienceChange} /> 3</label>
                  <label><input type="radio" name="experience" value="4" checked={experience === "4"} onChange={handleExperienceChange} /> 4</label>
                  <label><input type="radio" name="experience" value="5" checked={experience === "5"} onChange={handleExperienceChange} /> 5 - Great</label>
                </div>
              </div>
              <div class="question">
                <p><b>Was your issue resolved during your chat with Cimatron Copilot?</b></p>
                <div class="checkbox">
                  <label><input type="radio" name="resolved" value="true" checked={resolved === "true"} onChange={handleResolvedChange} /> Yes</label>
                  <label><input type="radio" name="resolved" value="false" checked={resolved === "false"} onChange={handleResolvedChange} /> No</label>
                </div>
              </div>
              <div class="question">
                <p><b>How would you rate the quality of the answers you got from Cimatron Copilot in this session?</b></p>
                <div class="rating">
                  <label><input type="radio" name="quality" value="1" checked={quality === "1"} onChange={handleQualityChange} /> 1 - Poor</label>
                  <label><input type="radio" name="quality" value="2" checked={quality === "2"} onChange={handleQualityChange} /> 2</label>
                  <label><input type="radio" name="quality" value="3" checked={quality === "3"} onChange={handleQualityChange} /> 3</label>
                  <label><input type="radio" name="quality" value="4" checked={quality === "4"} onChange={handleQualityChange} /> 4</label>
                  <label><input type="radio" name="quality" value="5" checked={quality === "5"} onChange={handleQualityChange} /> 5 - Great</label>
                </div>
              </div>
              <div class="question">
                <p><b>What can we do to improve the answers in this session or to improve Cimatron Copilot in general?</b></p>
                <textarea name="improvement" placeholder="Enter your suggestions..." value={commentText} onChange={(e) => setCommentText(e.target.value)}></textarea>
              </div>
              <div className="ms-auto">
                <div className="button-group mt-3">
                  <button
                    onClick={handleAddComment}
                    className="btn btn-primary comment-post"
                    disabled={!commentText.trim()}
                  >
                    Submit Feedback
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default Chat;
